"use client";

import React from "react";
import Link from "next/link";
import { ExternalLink } from "lucide-react";
import { Avatar } from "@/components/ui/avatar";
import { Badge } from "@/components/ui/badge";
import type { DomainContactCardProps } from "./types";

export const DomainContactCard: React.FC<DomainContactCardProps> = ({ contact }) => {
  return (
    <Link
      href={`/contacts/${contact.id}`}
      className="flex items-center gap-3 p-3 rounded-lg border hover:bg-card-50 transition-colors group"
    >
      <Avatar className="h-8 w-8">
        <div className="w-full h-full bg-green-100 flex items-center justify-center dark:bg-green-900/40">
          <span className="text-green-600 text-sm font-medium dark:text-green-400">
            {contact.displayName.charAt(0).toUpperCase()}
          </span>
        </div>
      </Avatar>

      <div className="flex-1 min-w-0">
        <div className="font-medium text-card-foreground truncate">{contact.displayName}</div>
        <div className="text-sm text-gray-500 truncate">
          {contact.email}
          {contact.company_name && (
            <>
              <span className="mx-1">•</span>
              <span className="text-blue-600">{contact.company_name}</span>
            </>
          )}
        </div>
      </div>

      <div className="flex items-center gap-2">
        {contact.status && (
          <Badge variant="outline" className="text-xs">
            {contact.status}
          </Badge>
        )}
        <ExternalLink className="h-4 w-4 text-gray-400 group-hover:text-gray-600 flex-shrink-0" />
      </div>
    </Link>
  );
};
